/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/**
 * Generates an object of omega event data.
 * @param {Object} data Omega event data.
 * @param {Object=} data.attributes Optional list of attributes.
 * @param {string} data.element The name or label of the element acted upon.
 * @param {Event} data.event The event.
 * @param {string=} data.feature The feature.
 * @param {Object=} data.widget The widget, a subset of the feature.
 * @returns {Object} Correctly formatted object of event information.
 */
export function getOmegaEvent({action, attributes, element, event, feature, type, widget}) {
  action = action || event.type;
  type = type || event.target && event.target.nodeName.toLowerCase();
  feature = feature || 'shell header';
  widget = widget || {name: element, type};

  let eventData = {action, element, feature, type, widget};
  if (attributes) {
    eventData['attributes'] = attributes;
  }
  return eventData;
}
